exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preference-info[data-v-2de2be7d]{font-size:13px;font-weight:700;margin-top:10px}a.pure-button-primary[data-v-2de2be7d],button.pure-button-primary[data-v-2de2be7d]{max-width:200px}.btn-primary[disabled][data-v-2de2be7d]{cursor:not-allowed;filter:alpha(opacity=65);opacity:.65;-webkit-box-shadow:none;box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2de2be7d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Features/Shared/VueComponents/DoorSales/Components/door-sales-preferences.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-2de2be7d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Features/Shared/VueComponents/DoorSales/Components/door-sales-preferences.vue
// module chunks = common